<template>

    <div class="account">
        <div class="row">
            <div class="col-24">
                <div class="account-header">
                    <h1 class="mb-0 ">Welcome back, {{userProfile.FirstName}}!</h1>
                </div>
            </div>
        </div>

        <div class="row g-0">
            <div class="col-xl-4">
                <div class="account-menu h-100">

                    <ul class="account-menu-list">
                        <li v-bind:class="{'active' : isActiveRoot('account_stay_bookings') || isActiveRoot('account_stay_booking') || isActiveRoot('account_spa_bookings') || isActiveRoot('account_spa_booking')}">
                            <router-link v-bind:to="{name : 'account_stay_bookings'}">
                                Your Bookings
                            </router-link>


                        </li>
                        <li v-bind:class="{'active' : isActiveRoot('account_details') || isActiveRoot('account_change_password')}">
                            <router-link v-bind:to="{name : 'account_details'}">
                                Account Details
                            </router-link>
                        </li>
                        <li v-bind:class="{'active' : isActiveRoot('account_preferences')}">
                            <router-link v-bind:to="{name : 'account_preferences'}">
                                Preferences
                            </router-link>
                        </li>
                        <li class="logout">
                            <a v-on:click="onLogout">
                                Logout
                            </a>

                        </li>
                    </ul>

                </div>

            </div>

            <div class="col-xl-20">
                <div class="account-content p-5 h-100">
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { accountStore } from '../store/index';

    export default {
        name: 'AccountRoot',
        computed: {
            currentStep() {
                return this.$route.name;
            },
            userProfile() {
                return accountStore.getters.userProfile;
            }
        },

        methods: {
            isActiveRoot(step) {
                return step == this.currentStep;
            },
            onLogout() {

                accountStore.dispatch("logout").then(() => {
                    this.$router.push({ name: 'account_login' });

                })
            }
        }
    }
</script>

<style>
    .account-header h1 {
        text-align: center;
        padding: 30px;
        margin: 0;
        text-transform: none !important;
        text-transform: none;
        background: #e2d8d5;
        margin: 0;
    }

    .account-menu {
        background: #eee9e7;
    }

    .account-menu-list {
        list-style: none;
        margin: 0;
        padding: 0;
    }

        .account-menu-list li {
            width: 100%;
        }

            .account-menu-list li a {
                display: block;
                width: 100%;
                height: 100%;
                padding: 20px;
                cursor: pointer;
                text-transform: uppercase;
                font-weight: bold;
                font-size: 14px;
                font-family: Montserrat;
            }

            .account-menu-list li:hover a,
            .account-menu-list li.active a {
                color: #fff !important;
                background: #425260;
            }


            .account-menu-list li.logout:hover a,
            .account-menu-list li.logout:active a {
                background: #fff !important;
                color: #425260 !important;
            }

    .account-content {
        background: white;
        width: 100%;
    }

    @media(min-width: 1200px) {
        .account-header h1 {
            padding: 60px;
        }


        .account-menu-list li a {
            padding: 40px;
        }
    }
</style>
